export const Camera = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5 8C9.83435 8 10.1466 7.8329 10.3321 7.5547L12.0352 5H19.9648L21.6679 7.5547C21.8534 7.8329 22.1656 8 22.5 8H29V25H3L3 8L9.5 8Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<circle cx="16" cy="16" r="5" stroke="currentColor" stroke-width="2"/>
</svg>`;
